import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { TestScoreProps } from '../TestScoreGauge'
import { TestScoreGauge } from '../TestScoreGauge'
import type { TooltipWithButtonProps } from '../Tooltip'
import { TooltipWithButton } from '../Tooltip'
import styles from './ProductScoreGauge.module.scss'

export const ProductScoreGauge: FunctionComponent<ProductScoreGaugeProps> = ({
  label = '',
  tooltip,
  testScoreGauge,
  variant = 'default',
  className,
}) => {
  const { textVariation } = testScoreGauge
  const scoreLabel =
    textVariation === 'pass' || textVariation === 'fail' ? 'Test result' : label

  return (
    <figure
      className={classnames(
        styles.scoreGaugeFigure,
        textVariation === 'obfuscated' && styles.restricted,
        variant === 'default' && styles.defaultVariant,
        variant === 'small' && styles.smallPortraitVariant,
        variant === 'small-landscape' && styles.smallLandscapeVariant,
        variant === 'compact' && styles.compactVariant,
        className
      )}
      data-testid="sb-product-score-gauge"
    >
      <figcaption
        data-testid="sb-product-score-gauge-header-container"
        className={classnames(
          styles.scoreGaugeFigureCaption,
          variant === 'compact' && styles.newRow
        )}
      >
        {scoreLabel}
        {tooltip && (
          <TooltipWithButton
            data-testid="product-score-gauge-tooltip"
            {...tooltip}
            className={styles.tooltip}
          />
        )}
      </figcaption>
      <TestScoreGauge
        {...testScoreGauge}
        variant={
          variant === 'default' || variant === 'compact' ? 'default' : 'small'
        }
      />
    </figure>
  )
}

///////// IMPLEMENTATION /////////

export type ProductScoreGaugeProps = {
  className?: string
  label?: string
  tooltip?: TooltipWithButtonProps
  testScoreGauge: TestScoreProps
  variant?: 'default' | 'small' | 'small-landscape' | 'compact'
}
